export default __webpack_public_path__ + "assets/webgl/scene-9.ea213fc2.glb";